import {
  SET_ACTIVE_WARNING_INDEX
} from './constants'

export const setActiveWarningIndex = index => ({
  type: SET_ACTIVE_WARNING_INDEX,
  payload: index
})
